import React from "react";

interface Order {
  id: string;
  orderId: string;
  merchantName: string | null;
  merchantBusinessName: string | null;
  merchantPhoneNumber: string | null;
  merchantEmail: string | null;
  merchantSocialMediaHandle: string | null;
  merchantSocialMediaPlatform: string | null;
  socialMediaPlatform: string | null;
  buyerName: string;
  buyerPhoneNumber: string;
  buyerEmail: string;
  buyerSocialMediaHandle: string | null;
  buyerSocialMediaPlatform: string | null;
  createdBy: string;
  status: string;
  code: string;
  created_at: string;
  updated_at: string;
}

interface Transaction {
  id: string;
  amount: number;
  type: string;
  status: string;
  created_at: string;
  order: Order;
}

interface OrderDetailsProps {
  transactions: Transaction;
}

const Details = ({
  title,
  value,
}: {
  title: string;
  value: string | number | null;
}) => {
  return (
    <div className="grid grid-cols-2 px-4 gap-20 mt-3">
      <h3 className="font-normal text-[14px]">{title}</h3>
      <h3 className="font-medium text-[14px] pt-1">{value ?? "N/A"}</h3>
    </div>
  );
};

const OrderDetails: React.FC<OrderDetailsProps> = ({ transactions }) => {
  return (
    <div className="bg-white border border-[#fff] mt-10 pt-7 rounded-lg w-full">
      <div className="px-4">
        <h3 className="font-semibold text-[14px]">Merchant’s Details</h3>
      </div>

      <Details
        title="Name:"
        value={transactions.order.merchantBusinessName}
      />
      <Details
        title="Business phone number:"
        value={transactions.order.merchantPhoneNumber}
      />
      <Details
        title="Business email address:"
        value={
          transactions.order.merchantEmail
            ? transactions.order.merchantEmail.length > 18
              ? transactions.order.merchantEmail
              : transactions.order.merchantEmail
            : "N/A"
        }
      />
      <Details
        title="Social media platform:"
        value={transactions.order.socialMediaPlatform}
      />
      <Details
        title="Social media handle:"
        value={transactions.order.merchantSocialMediaHandle}
      />

      <div className="px-4 mt-5">
        <h3 className="font-semibold text-[14px]">Buyer’s Details</h3>
      </div>

      <Details title="Name:" value={transactions.order.buyerName} />
      <Details
        title="Phone number:"
        value={transactions.order.buyerPhoneNumber}
      />
      <Details
        title="Email address:"
        value={
          transactions.order.buyerEmail
            ? transactions.order.buyerEmail.length > 18
              ? transactions.order.buyerEmail
              : transactions.order.buyerEmail
            : "N/A"
        }
      />
      <Details
        title="Social media platform:"
        value={transactions.order.buyerSocialMediaPlatform}
      />
      <Details
        title="Social media handle:"
        value={transactions.order.buyerSocialMediaHandle}
      />
      <Details title="Amount:" value={transactions.amount} />
    </div>
  );
};

export default OrderDetails;
